export default {
  path: '/report',
  title: '报台管理',
  icon: 'th-list',
  children: [{
    path: '/report/center',
    title: '报台中心',
    icon: 'th-large'
  }]
};